module.exports = __webpack_public_path__ + "img/glassquality_4.5975e25a.png";